












import { defineComponent } from "@vue/composition-api";


export default defineComponent({
    props: {
        title: String,
        icon: String,
        borderBottom: Boolean,
    },
    setup(props, context) {
    }
});
